import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { ContractsService } from '../services/contracts.service';


@Injectable({
  providedIn: 'root',
})
export class ContractsGuard implements CanActivate {
  loggedInStatus: boolean = false;

  constructor(private router: Router, private contractsService: ContractsService) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    const token = getCookie('myesse_access_token');

    if (this.loggedInStatus) {
      return true;
    }

    const usedIdp = getCookie('active_idp');
    if (usedIdp === 'ias-white-oidc' || usedIdp === 'ias-blue-oidc') {
      localStorage.setItem('oidc-login', usedIdp);
    } else {
      return false;
    }

    const requestId = next.queryParams['id'];
    let contract: any | null = null;
    const result = await this.contractsService.getContractById(requestId, token!);
    this.loggedInStatus = result.valid;
    contract = await result.media;


    if (this.loggedInStatus && contract) {
      this.router.navigate(['/contracts', contract?.url]);
    } else {
      this.router.navigate(['/auth/login']);
    }

    return this.loggedInStatus;
  }
}
